import { render, staticRenderFns } from "./PatientCardRadiology.vue?vue&type=template&id=16411396&scoped=true"
import script from "./PatientCardRadiology.vue?vue&type=script&lang=js"
export * from "./PatientCardRadiology.vue?vue&type=script&lang=js"
import style0 from "./PatientCardRadiology.vue?vue&type=style&index=0&id=16411396&prod&scoped=true&lang=css"
import style1 from "./PatientCardRadiology.vue?vue&type=style&index=1&id=16411396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16411396",
  null
  
)

export default component.exports